<script lang="ts">
  import { computed, defineComponent } from 'vue'
  import { useRoute } from 'vue-router'

  import BfToastViewport from '@/components/ui/bahnhof/BfToastViewport.vue'

  export default defineComponent({
    name: 'TheAppLayout',
    components: { BfToastViewport },
    setup() {
      const route = useRoute()
      const layout = computed(() => {
        const layout = route?.meta?.layout
        if (layout) {
          return layout
        }
        return 'div'
      })
      return {
        layout,
      }
    },
  })
</script>

<template>
  <component :is="layout">
    <router-view />
  </component>
  <IndexNotification v-if="layout === 'div'" />
  <OnlyMobileUseNotification />
  <BfToastViewport />
</template>
